import GenericLangValue from "./GenericLangValue";
import AdmsIdentifier from "./AdmsIdentifier";
import {keys} from "../config/nameSpacesKeys";
// import {assetKeys} from "../../config/constants";

export default class HasOriginalSourceObj {
  constructor(name, initialValue, namespace, admsNameSpace, notationNameSpace, schemaAgencyNameSpace) {
    // console.log(namespace);
    this.namespace = namespace;
    this.name = name;
    this.title = new GenericLangValue(name = "title", null, keys.title);
    this.admsNameSpace = admsNameSpace;
    this.notationNameSpace = notationNameSpace;
    this.schemaAgencyNameSpace = schemaAgencyNameSpace;
    this.admsList = [];
    if (initialValue) {
      this.parseInputJSON(initialValue);
    } else {
      this.createEmptyAdmsObj();
    }
  }

  getNameSpace() {
    return this.namespace;
  }

  getTitle() {
    return this.title;
  }

  setTitle(titleObj) {
    this.title = titleObj;
  }

  getAdmsIdentifiersList() {
    return this.admsList;
  }

  setAdmsIdentifiersList(fadmsList) {
    this.admsList = fadmsList;
  }

  createEmptyAdmsObj() {
    const adms = new AdmsIdentifier(this.name, null, this.admsNameSpace, this.notationNameSpace, this.schemaAgencyNameSpace);
    this.admsList.push(adms);
  }

  createAdmsObj(obj) {
    const adms = new AdmsIdentifier(this.name, obj, this.admsNameSpace, this.notationNameSpace, this.schemaAgencyNameSpace);
    // adms.parseInputJSON(obj);
    this.admsList.push(adms);
  }

  removeAdmsObj(obj, index) {
    if (index < 0 || index >= this.admsList.length) {
      return false;
    }
    this.admsList.splice(index, 1);
  }

  setAdms(inputObj) {
    const admsObj = inputObj[this.admsNameSpace];
    if (Array.isArray(admsObj)) {
      for (const entry of Object.entries(admsObj)) {
        const value = entry[1];
        this.createAdmsObj(value);
      }
    } else {
      // this.createAdmsObj(admsObj);
    }
  }

  parseInputJSON(inputJSON) {
    const obj = inputJSON;
    if (Array.isArray(obj)) {
      for (const entry of Object.entries(obj)) {
        const value = entry[1];
        this.parseObj(value);
      }
    } else {
      this.parseObj(obj);
    }
  }

  parseObj(obj) {
    this.title.parseInputJSON(obj);
    this.setAdms(obj);
  }


  getExpandedFormatValue() {
    const obj = {};
    const titleExpanded = this.title.getExpandedFormatValue();
    obj[this.title.getNameSpace()] = titleExpanded;

    const admsExpanded = [];
    for (let index = 0; index < this.admsList.length; index++) {
      const admsItem = this.admsList[index];
      admsExpanded.push(admsItem.getExpandedFormatValue());
    }
    obj[this.admsNameSpace] = admsExpanded;
    // obj[assetKeys.type] = [`${this.namespace}`];
    return obj;
  }

  isEmpty() {
    const condition1 = this.title.isEmpty();
    let condition2 = true;
    for (let index = 0; index < this.admsList.length; index++) {
      const admsItem = this.admsList[index];
      condition2 = condition2 && admsItem.isEmpty();
    }
    return condition1 && condition2;
  }
}
